import { Button } from '@/components/form/Button';
import { useControls } from '@/components/multistep/useMultistep';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/table/Table';
import { ParseRowError, ValidateRowError } from '@/services/csv/helpers/process';
import { useResult } from '@/services/csv/useCSVService';
import { useBulkFinanceSmartNext } from '../helpers/useBulkFinanceSmartNext';
import { Result } from './UploadFinanceModelStep';

const HAS_HEADERS = 1;

export const ValidationError = (error: ValidateRowError) => {
  return (
    <>
      {error.issues.map((issue, i) => {
        const row = error.index + HAS_HEADERS + 1;
        return (
          <TableRow key={i} className="hover:bg-muted/50">
            <TableCell className="font-medium">{row}</TableCell>
            <TableCell>{issue.path.join('')}</TableCell>
            <TableCell>{issue.message}</TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export const ParseError = (error: ParseRowError) => {
  const row = error.index + HAS_HEADERS;
  return (
    <TableRow className="hover:bg-muted/50">
      <TableCell className="font-medium">{row}</TableCell>
      <TableCell>{error.error.message}</TableCell>
    </TableRow>
  );
};

export const FinanceModelIssuesStep = () => {
  const result = useResult<Result>();
  const next = useBulkFinanceSmartNext();
  const { previous } = useControls();
  if (!result) throw Error('No result');

  return (
    <div className="space-y-3">
      <div className="space-y-2 font-medium overflow-y-auto max-h-[200px]">
        {result.errors.genericErrors?.map((error, index) => (
          <p key={`duplicateProductError-${index}`}>{error.message}</p>
        ))}
      </div>

      {result.errors.couldNotParse.length !== 0 && (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Row</TableHead>
              <TableHead>Issue</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {result.errors.couldNotParse.map(m => (
              <ParseError key={m.index} {...m} />
            ))}
          </TableBody>
        </Table>
      )}
      {result.errors.couldNotValidate.length !== 0 && (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Row</TableHead>
              <TableHead>Column</TableHead>
              <TableHead>Issue</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {result.errors.couldNotValidate.map((m, i) => (
              <ValidationError key={i} {...m} />
            ))}
          </TableBody>
        </Table>
      )}
      <div className="flex justify-between">
        <Button onClick={previous}>Previous</Button>
        <Button disabled={Object.keys(result.errors).length > 0} onClick={() => next(result)}>
          Next
        </Button>
      </div>
    </div>
  );
};
